<template>
    <div class="vm-plan-edit" :class="{ 'is-hide': is_hide && product_type == 0}">
        <template v-if="is_sale_type">
            <div v-if="plan.status == plan_status.normal" class="flex-box flex-a-center mb24">
                <span class="green fs14 pointer" @click="$mixin_router_push(`/item/${plan.plan_id}`, true,'','', plan)">{{$t('c.PlanEdit.text1')}}</span>
            </div>
            <div v-if="is_hide" class="flex-box flex-a-center mb16">
                <div @click="$mixin_router_push(`/item/${plan.plan_id}`, true,'','', plan)" class="pointer flex-box flex-center icon-box radius mr8">
                    <i class="afd afd-link black-8"></i>
                </div>
                <span class="black-9 fs14 pointer" @click="$mixin_router_push(`/item/${plan.plan_id}`, true,'','', plan)">{{$t('c.PlanEdit.text2')}}</span>
            </div>
            <div v-if="is_hide" class="over mb24">
                <div class="pay-switch flex-box flex-align-items-center flex-justify-content-space-between fs14">
                    {{$t('c.PlanEdit.text3')}}
                    <switches
                        theme="custom"
                        color="purple"
                        v-model="can_buy_hide"
                    ></switches>
                </div>
            </div>
            <!-- <div class="mb24 fwb black-8 fs-16-14 mq lh1">商品基本信息</div>  -->
        </template>
        <template v-if="!is_hide_acion_btn">
            <i class="afd afd-x black-3 del-x-1" @click="remove"></i>
            <i
                class="afd afd-eye black-3"
                v-if="!is_hide"
                @click="toggle('hide')"
            ></i>
            <div
                class="flex-box afd-eye-off-box flex-align-items-center lh1 purple pointer"
                @click="toggle('show')"
                v-if="is_hide"
            >
                {{$t('c.PlanEdit.text4')}}
                <i class="afd afd-eye-off ml8"></i>
            </div>
        </template>
        <div>
            <input
                type="text"
                v-model="name"
                class="gl-input w75 pt0"
                :placeholder="text.name"
            />
        </div>
        <div class="flex-box mt16 flex-justify-content-space-between flex-align-items-baseline">
            <div class="flex-box flex-align-items-baseline">
                <div class="black-3 flex-box flex-align-items-center fs32">
                    <span :class="{ purple: price != '' }">￥</span>
                    <input
                        type="text"
                        inputmode="decimal"
                        v-model="price"
                        class="purple fs32 money-input"
                        placeholder="00.00"
                    />
                </div>
                <span class="black-3">/ {{ text.unit }}</span>
                <span class="black-3 ml16 fs12">{{$t('c.PlanEdit.text5')}} ￥{{is_sale_type ? '1' : '5'}}.00</span>
            </div>
            <div v-if="plan.sponsor_count > 0 && browser_size != 'small'" class="black-8 fs14">{{product_type == 1 ? $t('c.PlanEdit.text6') : $t('c.PlanEdit.text7')}} {{plan.sponsor_count}}</div>
        </div>
        <div v-if="plan.sponsor_count > 0 && browser_size == 'small'" class="black-8 fs14 mt10">{{product_type == 1 ? $t('c.PlanEdit.text6') : $t('c.PlanEdit.text7')}} {{plan.sponsor_count}}</div>
        <textarea-autosize
            v-if="product_type == 0"
            class="gl-textarea fs16 mt16"
            v-model="desc"
            :placeholder="text.desc"
            :min-height="100"
            :max-height="200"
        ></textarea-autosize>
        <btn v-if="product_type == 0" class="w100 look2 mt16 pt10 pb10" @click.native="open_sheet_plan_desc">+ 添加赞助奖励</btn> 
        <div class="img-box mt16">
            <div class="img-pre-box" v-if="pic">
                <pic width="320" height="180" type="2" :src="pic"></pic>
            </div>
            <div class="flex-box flex-a-center">
                <btn v-if="!pic" class="look3 flex-align-self-end mq fs-14-12 pt10 pb10" :text="is_bundle ? $t('c.PlanEdit.text8') : product_type == 1 ? $t('c.PlanEdit.text9'): $t('c.PlanEdit.text10')">
                    <vue-core-image-upload
                        v-if="is_client"
                        class="gl-upload"
                        :crop="false"
                        @imageuploaded="image_upload"
                        @errorhandle="errorhandle"
                        text
                        :inputOfFile="upload.name"
                        :max-file-size="upload.max_file_size"
                        :url="upload.img_common_url"
                    ></vue-core-image-upload>
                </btn>
                <btn
                    v-else
                    class="flex-align-self-end look1"
                    @click.native="remove_pic"
                >{{$t('c.PlanEdit.text11')}}</btn>
                <span class="ml16 black-3 lh1 fs12">{{$t('c.PlanEdit.text12')}}</span>
            </div>
        </div>
        <editor
            v-if="is_sale_type"
            class="mt16"
            ref="editor"
            :conf="conf"
            :content="desc"
        ></editor>
        <div v-if="product_type == 3" class="mt16 flex-box flex-bet flex-a-center">
          <span class="fs14">{{$t('c.PlanEdit.text13')}}</span>
          <input type="text" inputmode="numeric" v-model="plan.bundle_sku_select_count" class="gl-input goods-num-input fs12" :placeholder="$t('c.PlanEdit.text14')"/>
        </div>
        <div v-if="is_bundle" class="mt16">
          <input type="text" inputmode="numeric" v-model="plan.bundle_stock" class="gl-input goods-num-input fs12" :placeholder="$t('c.PlanEdit.text15')"/>
        </div>
        <section class="mt24" v-if="is_sale_type">
            <div class="flex-box flex-align-items-center">
                <checkbox
                        class="pointer baseline"
                        :class="{ black: need_address }"
                        v-model="need_address"
                >{{$t('c.PlanEdit.text16')}}
                </checkbox>
            </div>
        </section>
        <section class="mt24" v-if="product_type == 1 && !is_bundle">
            <div class="flex-box flex-align-items-center">
                <checkbox class="pointer baseline" :class="{ black: vip_price_switch }" v-model="vip_price_switch">{{$t('c.PlanEdit.text17')}}</checkbox>
                <i class="afd afd-help ml8 gl-hover-text fwn black-3" v-tooltip.top="{content: $t('c.PlanEdit.text18'),trigger:browser_size == 'small' ? 'click':`hover`, classes:'look2'}"></i>
            </div>
            <template v-if="vip_price_switch">
                <div class="flex-box flex-bet flex-a-center price-box p12 mt16">
                    <input class="gl-input no-border p0" inputmode="decimal" placeholder="00.00" v-model="vip_price"/>
                    <span class="black-3">{{$t('c.PlanEdit.text19')}}</span>
                </div>
                <multiselect
                    class="flex-item-1 btn look4 multiselect-permission up mt16"
                    :allowEmpty="false"
                    v-model="vip_item"
                    :options="vip_list"
                    track-by="name"
                    label="name"
                    :searchable="false"
                    :show-labels="false"
                    :placeholder="$t('c.PlanEdit.text20')"
                ></multiselect>
                <div class="flex-box mt16 flex-bet flex-a-center">
                  <div class="fs14 black-5">{{$t('c.PlanEdit.text108')}}</div>
                  <switches theme="custom" color="purple" v-model="is_include_history"></switches>
                </div>
            </template>
        </section>
        <section class="mt24" v-if="is_sale_type">
            <div class="flex-box flex-bet flex-a-center">
                <div class="flex-box flex-align-items-center">
                    <span class="fs14">{{$t('c.PlanEdit.text21')}}</span>    
                    <i class="afd afd-help ml8 gl-hover-text fwn black-3" v-tooltip.top="{content: $t('c.PlanEdit.text22'),trigger:browser_size == 'small' ? 'click':`hover`, classes:'look2'}"></i>
                </div>
                <switches theme="custom" color="purple" v-model="is_time_limit_price"></switches>
            </div> 
            <template v-if="is_time_limit_price">
                <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center fs12">
                    <span class="black-5">{{$t('c.PlanEdit.text23')}}</span>
                    <dropdown class="discount-dropdown" :options="discount_list" :placeholder="$t('c.PlanEdit.text24')" :value="discount_index" @dropdown_tap="dropdown_tap"/>
                </div>
                <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center fs12">
                    <span class="black-5">{{$t('c.PlanEdit.text25')}}</span>
                    <date-picker type="datetime" format="YYYY-MM-DD HH:mm" :placeholder="$t('c.PlanEdit.text87')" :editable="false" v-model="begin_time"></date-picker>
                </div>
                <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center fs12">
                    <span class="black-5 flex-item-1">{{$t('c.PlanEdit.text26')}}</span>
                    <date-picker type="datetime" format="YYYY-MM-DD HH:mm" :placeholder="$t('c.PlanEdit.text27')" :editable="false" v-model="end_time"></date-picker>
                </div>
            </template>
        </section>
        <remark-config v-if="is_sale_type" class="mt24" :has_plan_config.sync="plan.has_plan_config" :remark_name.sync="plan.config.remark_name" :remark_placeholder.sync="plan.config.remark_placeholder" :remark_required.sync="plan.config.remark_required" is_show_required="true"/>
        <template v-if="product_type == 1 && !is_bundle">
            <div class="fs-16-14 mq fwb black-8 mt32">{{$t('c.PlanEdit.text28')}}</div>
            <div class="mt32" v-for="(item, i) in sku" :key="i">
                <div class="flex-box flex-align-items-center">
                    <i class="afd afd-x del-x-2 fs12 pt12 pr16 pb10 black-3 gl-hover-text" @click="sku_del(i)"></i>
                    <span class="pr10 goods-index fs14 fwb pt10 pb10"
                        >#{{ i + 1 }}</span
                    >
                    <input
                        type="text"
                        v-model="item.name"
                        class="gl-input fs14"
                        :placeholder="$t('c.PlanEdit.text29')"
                    />
                </div>

                <div class="pl48">
                    <div v-if="item.sponsor_count > 0" class="mt16 black-8 fs14">{{$t('c.PlanEdit.text30')}} {{item.sponsor_count}}</div>
                    <div class="mt16">
                        <input
                            type="text"
                            inputmode="numeric"
                            v-model="item.stock"
                            class="gl-input goods-num-input fs12"
                            :placeholder="$t('c.PlanEdit.text31')"
                        />
                    </div>
                    <div class="img-pre-box mt16" style="max-width:150px" v-if="item.pic">
                        <pic width="320" height="180" type="2" :src="item.pic"></pic>
                    </div>
                    <btn v-if="!item.pic" class="look3 pt10 pb10 flex-align-self-end mt16 mq fs-14-12" :text="$t('c.PlanEdit.text32')" @click.native="pick_item(item)">
                        <vue-core-image-upload
                            v-if="is_client"
                            class="gl-upload"
                            :crop="false"
                            @imageuploaded="image_sku_upload"
                            @errorhandle="errorhandle"
                            text
                            :inputOfFile="upload.name"
                            :max-file-size="upload.max_file_size"
                            :url="upload.img_common_url"
                        ></vue-core-image-upload>
                    </btn>
                    <btn
                        v-else
                        class="flex-align-self-end look1 mt16"
                        @click.native="remove_sku_pic(item)"
                    >{{$t('c.PlanEdit.text33')}}</btn>
                   
                    <!-- <div class="flex-box mt16">
                      <pic v-if="session_user" :src="session_user.avatar" width="48" height="48" class="wh48 mr16 radius2"/> 
                      <div>
                        <div class="text-overflow-1 fs14 black-8 fwb mt2">第一章</div> 
                        <div class="text-overflow-1 mt4 black-5 fs12">150年前的画家还不知道这些已…</div> 
                      </div>
                    </div> -->
                    <!-- <textarea-autosize
                        class="gl-textarea goods-textarea fs16 mt16"
                        v-model="item.reply_content"
                        placeholder="自动回复私信（选填）"
                        :min-height="70"
                        :max-height="200"
                    ></textarea-autosize> -->
                    <div class="flex-box flex-align-items-center tab-option mt24 fs14 pointer" @click="tab_sku_option(item)">
                        <i class="afd fs16 mr8" :class="item.is_show_option ? 'afd-arrow-up' : 'afd-arrow-down'"></i>
                        {{$t('c.PlanEdit.text34')}}
                    </div>
                    <section v-if="item.is_show_option">
                        <!-- <btn class="fs14 look3 mt16"><i class="afd afd-link mr8"></i>添加附件</btn> -->
                        <div v-if="can_add_product_post" class="flex-box flex-bet flex-a-center mt20">
                          <div class="flex-box flex-align-items-center">
                              <checkbox class="gl-hover-text pointer baseline" v-model="item.feed_switch">{{$t('c.PlanEdit.text35')}}</checkbox>
                              <i class="afd afd-help black-3 ml8 gl-hover-text" v-tooltip.top="{content: $t('c.PlanEdit.text88'),trigger:browser_size == 'small' ? 'click':`hover`, classes:'look2'}"></i>
                          </div>
                          <span v-if="item.post_id" class="black-3 gl-hover-text fs14" @click="del_sku_post(item)">{{$t('c.PlanEdit.text36')}}</span>  
                        </div>
                        <btn v-if="item.feed_switch && !item.post_id" class="look3 pt10 pb10 flex-align-self-end mt16 mq fs-14-12" text="发布动态" @click.native="open_modal_feed(i)"></btn>
                        <feed-small class="mt16 pointer" v-if="item.feed_switch && item.post_id" :post="item.post" @click.native="open_modal_feed(i)"/>
                        <template v-if="!item.feed_switch">
                          <div class="mt20 fs14 lh1 fwb" v-if="can_add_attachment">{{$t('c.PlanEdit.text37')}}</div>
                          <editor
                              v-if="can_add_attachment"
                              class="mt16"
                              :ref="`editor_${i}`"
                              :conf="sku_conf"
                              :content="item.purchased_rich_text"
                          ></editor>
                          <upload-cloud-file v-if="can_add_attachment" :files="item.attachment" class="mt20"/>
                        </template>
                        <section class="mt20 auto-reply">
                            <div class="flex-box flex-align-items-center flex-justify-content-space-between black-8">
                                <div class="flex-box flex-align-items-center">
                                    <checkbox class="gl-hover-text pointer baseline" v-model="item.reply_switch">{{$t('c.PlanEdit.text38')}}</checkbox>
                                    <i class="afd afd-help black-3 ml8 gl-hover-text" v-tooltip.top="{content: $t('c.PlanEdit.text39'),trigger:browser_size == 'small' ? 'click':`hover`, classes:'look2'}"></i>
                                </div>
                            </div>
                            <textarea-autosize
                                v-if="item.reply_switch"
                                class="gl-textarea fs16 mt16"
                                v-model="item.reply_content"
                                :placeholder="$t('c.PlanEdit.text40')"
                                :min-height="100"
                                :max-height="100"
                            ></textarea-autosize>
                        </section>
                        <section class="mt24 auto-reply">
                            <div class="flex-box flex-align-items-center flex-justify-content-space-between black-8">
                                <div class="flex-box flex-align-items-center">
                                    <checkbox class="gl-hover-text pointer baseline" v-model="item.reply_random_switch">
                                        <p>{{$t('c.PlanEdit.text41')}}<span class="black-3">{{$t('c.PlanEdit.text42')}}</span></p>
                                    </checkbox>
                                    <i class="afd afd-help black-3 ml8 gl-hover-text"  v-tooltip.top="{content: $t('c.PlanEdit.text43'),trigger:browser_size == 'small' ? 'click':`hover`, classes:'look3'}"></i>
                                </div>
                                <span v-if="item.reply_random_switch && item.reply_random_num > 0" class="black-3 fs14">{{$t('c.PlanEdit.text44')}} {{ item.reply_random_num }}</span>
                            </div>
                            <textarea-autosize
                                v-if="item.reply_random_switch"
                                class="gl-textarea fs16 mt16"
                                v-model="item.reply_random_content"
                                :placeholder="$t('c.PlanEdit.text45')"
                                :min-height="100"
                                :max-height="100"
                            ></textarea-autosize>
                        </section>
                        <section class="mt24" v-if="!item.feed_switch">
                            <btn class="look3 pt10 pb10 mq fs-14-12"  v-if="session_user && session_user.rights.sale_connect_album && !(item.album && item.album.album_id)" @click.native="pick_album(item, i)">{{$t('c.PlanEdit.text46')}}</btn>
                            <template v-if="item.album && item.album.album_id">
                                <div class="item-box flex-box" >
                                    <pic class="cover" :src="item.album.cover" width="64" height="64"/>
                                    <div class="ml16 flex-item-1 flex-box flex-justify-content-space-between">
                                        <div class="">
                                            <div class="fs14">{{item.album.title}}</div>
                                            <div class="fs12 black-3">{{$time_show(item.update_time)}}</div>
                                        </div>
                                        <div>
                                            <i class="afd afd-trans fs12 pl16 pb16 black-3 gl-hover-text" @click="pick_album(item, i)"></i>
                                            <i class="afd afd-x fs12 pl16 pb16 black-3 gl-hover-text" @click="remove_album(i)"></i>
                                        </div>

                                    </div>
                                </div>
                                <div class="mt16 forever fs12">{{$t('c.PlanEdit.text47')}}</div>
                            </template>
                        </section>
                    </section>
                    <div v-if="plan_id" class="flex-box flex-align-items-center tab-option mt24 fs14 pointer" @click="tab_sku_ad_option(item)">
                        <i class="afd fs16 mr8" :class="item.is_show_ad_option ? 'afd-arrow-up' : 'afd-arrow-down'"></i>
                        {{$t('c.PlanEdit.text48')}}
                    </div>
                    <section v-show="item.is_show_ad_option">
                        <div class="mt24 fwb fs14 flex-box flex-justify-content-space-between">
                            {{$t('c.PlanEdit.text49')}}
                            <div class="purple fwn gl-hover-text-purple" @click="$mixin_router_push(`/setting/redeem?plan_id=${plan_id}&sku_id=${item.sku_id}`)">
                                {{$t('c.PlanEdit.text50')}}
                            </div>
                        </div>
                        <div v-if="item.redeem" class="flex-box flex-align-items-center black-3 fs12 mt16">
                            <div>
                                {{$t('c.PlanEdit.text51')}}
                                <span class="black">{{ item.redeem.total_count }}</span>
                            </div>
                            <div class="ml16">
                                {{$t('c.PlanEdit.text52')}}
                                <span class="black">{{ item.redeem.used_count }}</span>
                            </div>
                            <div class="ml16">
                                {{$t('c.PlanEdit.text53')}}
                                <span class="black">
                                    {{ item.redeem.pending_count }}
                                </span>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div
                class="flex-box flex-center black-3 mt24 pointer add-sku-btn"
                @click="sku_push"
            >
                <i class="afd afd-plus fs12"></i>
                <span class="ml8 fs12">{{$t('c.PlanEdit.text54')}}</span>
            </div>
        </template>
        <template v-if="product_type == 0">
            <div class="flex-box flex-align-items-center tab-option mt24 fs14 pointer" @click="tab_option">
                <i class="afd fs16 mr8" :class="is_show_option ? 'afd-arrow-up' : 'afd-arrow-down'"></i>
                {{product_type == 0 ? $t('c.PlanEdit.text55') : $t('c.PlanEdit.text56')}}
            </div>
            <section v-if="is_show_option">
                <section class="mt24 auto-reply">
                    <div class="flex-box flex-align-items-center flex-justify-content-space-between black-8">
                        <div class="flex-box flex-align-items-center">
                            <checkbox class="gl-hover-text pointer baseline" v-model="reply_switch">{{$t('c.PlanEdit.text57')}}</checkbox>
                            <i class="afd afd-help black-3 ml8 gl-hover-text" v-tooltip.top="{content: $t('c.PlanEdit.text58'),trigger:browser_size == 'small' ? 'click':`hover`, classes:'look2'}"></i>
                        </div>
                    </div>
                    <textarea-autosize
                        v-if="reply_switch"
                        class="gl-textarea fs16 mt16"
                        v-model="reply_content"
                        :placeholder="$t('c.PlanEdit.text59')"
                        :min-height="100"
                        :max-height="100"
                    ></textarea-autosize>
                </section>
                <section class="mt24 auto-reply">
                    <div class="flex-box flex-align-items-center flex-justify-content-space-between black-8">
                        <div class="flex-box flex-align-items-center">
                            <checkbox class="gl-hover-text pointer baseline" v-model="reply_random_switch">
                                <p>{{$t('c.PlanEdit.text60')}}<span class="black-3">{{$t('c.PlanEdit.text61')}}</span></p>
                            </checkbox>
                            <i class="afd afd-help black-3 ml8 gl-hover-text" v-tooltip.top="{content:$t('c.PlanEdit.text62'),trigger:browser_size == 'small' ? 'click':`hover`, classes:'look3'}"></i>
                        </div>
                        <span v-if="reply_random_switch && plan.reply && plan.reply.reply_random_num > 0" class="black-3 fs14">{{$t('c.PlanEdit.text63')}} {{ plan.reply.reply_random_num }}</span>
                    </div>
                    <textarea-autosize
                        v-if="reply_random_switch"
                        class="gl-textarea fs16 mt16"
                        v-model="reply_random_content"
                        :placeholder="$t('c.PlanEdit.text64')"
                        :min-height="100"
                        :max-height="100"
                    ></textarea-autosize>
                </section>
                <remark-config class="mt24" :has_plan_config.sync="plan.has_plan_config" :remark_name.sync="plan.config.remark_name" :remark_placeholder.sync="plan.config.remark_placeholder" :remark_required.sync="plan.config.remark_required"/>
                <section class="mt24">
                    <div class="flex-box flex-align-items-center flex-justify-content-space-between black-8">
                        <div class="flex-box flex-align-items-center">
                            <checkbox class="pointer baseline" :class="{ black: need_address }" v-model="need_address">{{$t('c.PlanEdit.text65')}}</checkbox>
                        </div>
                    </div>
                </section>
                <section class="mt24">
                    <div class="flex-box flex-align-items-center flex-justify-content-space-between black-8">
                        <div class="flex-box flex-align-items-center">
                            <checkbox class="pointer baseline" :class="{ black: independent }" v-model="independent">
                                <p>{{$t('c.PlanEdit.text66')}}<span class="black-3">{{$t('c.PlanEdit.text67')}}</span></p>
                            </checkbox>
                        </div>
                    </div>
                </section>
                <section class="mt24" v-if="session_user && session_user.rights.add_permanent_plan">
                    <div class="flex-box flex-align-items-center flex-justify-content-space-between black-8">
                        <div class="flex-box flex-align-items-center">
                            <checkbox class="pointer baseline" :class="{ black: permanent }" v-model="permanent">
                                <pre>{{$t('c.PlanEdit.text68')}}
    
                                </pre>
                            </checkbox>
                        </div>
                    </div>
                </section>
                <section class="mt24" v-if="!is_hard_code_year_plan && !is_hard_code_q_plan">
                    <div class="fwb fs14 flex-box flex-justify-content-space-between">
                        {{$t('c.PlanEdit.text69')}}
                    </div>
                    <div class="flex-box flex-align-items-center black-8 mt16 fs14">
                        <radio class="mr24" name="pay_month" v-model="pay_month" value="1" :checked="pay_month == 1">{{$t('c.PlanEdit.text70')}}</radio>
                        <radio class="mr24" name="pay_month" v-model="pay_month" value="3" :checked="pay_month == 3">{{$t('c.PlanEdit.text71')}}</radio>
                        <radio name="pay_month" v-model="pay_month" value="12" :checked="pay_month == 12">{{$t('c.PlanEdit.text72')}}</radio>
                    </div>
                    <div class="fs12 black-3 mt8">{{$t('c.PlanEdit.text73')}}</div>
                    <div v-if="pay_month == 3 || pay_month == 12" class="flex-box flex-a-center mt16 fs14 flex-wrap">
                        <span class="black-8 mr16">{{$t('c.PlanEdit.text74')}}</span>
                        <div class="flex-box flex-a-center mr16">
                            <input class="gl-input" :placeholder="''" v-model="favorable_price_pre"/>
                            <span class="black-3">{{$t('c.PlanEdit.text75')}}</span>
                        </div>
                        <span class="black-8 mr16">/{{pay_month == 3 ? $t('c.PlanEdit.text76') : pay_month == 12 ? $t('c.PlanEdit.text77') : $t('c.PlanEdit.text78')}}</span>
                        <span v-if="price" class="black-3">{{$t('c.PlanEdit.text79')}} <s>￥{{(price * pay_month).toFixed(2)}}</s></span>
                    </div>
                </section>
                <section class="mt24" v-if="plan && plan.redeem">
                    <div class="fwb fs14 flex-box flex-justify-content-space-between">
                        {{$t('c.PlanEdit.text80')}}
                        <div class="purple fwn gl-hover-text-purple" @click="$mixin_router_push(`/setting/redeem?plan_id=${plan_id}`)">
                            {{$t('c.PlanEdit.text81')}}
                        </div>
                    </div>
                    <div class="flex-box flex-align-items-center black-3 fs12 mt16">
                        <div>
                            {{$t('c.PlanEdit.text82')}}
                            <span class="black">{{ plan.redeem.total_count }}</span>
                        </div>
                        <div class="ml16">
                            {{$t('c.PlanEdit.text83')}}
                            <span class="black">{{ plan.redeem.used_count }}</span>
                        </div>
                        <div class="ml16">
                            {{$t('c.PlanEdit.text84')}}
                            <span class="black">
                                {{ plan.redeem.pending_count }}
                            </span>
                        </div>
                    </div>
                </section>
            </section>
        </template>
        <div v-if="!is_hide_save" class="flex-box flex-direction-row-reverse mt16">
            <btn class="look3 pt12 pb12" :class="browser_size == 'small' ? 'w100' : ''" @click.native="save">{{$t('c.PlanEdit.text85')}}</btn>
        </div>
        <div v-if="is_hide && product_type == 0" class="over">
            <div
                class="pay-switch p16 flex-box flex-align-items-center flex-justify-content-space-between"
            >
                {{$t('c.PlanEdit.text86')}}
                <switches
                    theme="custom"
                    color="purple"
                    v-model="can_buy_hide"
                ></switches>
            </div>
        </div>
    </div>
</template>

<script>
const editor = () => ({ component: import("@/components/editor") });
import DatePicker from 'vue2-datepicker'; //https://github.com/mengxiong10/vue2-datepicker/blob/master/README.zh-CN.md
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import RemarkConfig from "@/components/RemarkConfig";

import { mapState } from "vuex";
import {
    POST_EDIT_PLAN,
    POST_DEL_PLAN,
    POST_CREATOR_HIDE_PLAN,
    POST_CREATOR_SHOW_PLAN,
    POST_SET_CAN_BUY_HIDE,
    POST_POST_DELETE,
} from "@/api/config";
export default {
    name: "plan-edit",
    props: {
        plan: {
            type: Object,
            default() {
                return {};
            },
        },
        index: {
            type: Number,
            default() {
                return 0;
            },
        },
        product_type: {
            type: [String, Number],
            default() {
                return 0;
            },
        },
        is_bundle: {
            default() {
                return false;
            },
        },
        is_hide_save: {
            default() {
                return false;
            },
        },
        is_hide_acion_btn:{
            default() {
                return false;
            },
        },
        bundle_sku_list:{
            default() {
                return [];
            },
        }
    },
    components: {
        editor,
        DatePicker,
        RemarkConfig
    },
    data() {
        let r = this.plan.reply ? this.plan.reply : {};
        let plan = this.plan;
        let sku = this.plan.sku;
        let sku_tpl = {
            sku_id: "",
            name: "",
            stock: "",
            reply_content: "",
            reply_random_content: "",
            is_show_option: false,
            is_show_ad_option:false,
            reply_switch: false,
            album:{},
            album_id:'',
            pic:'',
            attachment:[],
            purchased_rich_text:'',
            sku_placeholder:'这里是用户付费后解锁的内容',
            feed_switch:false,
        };
        // console.log(this.product_type == 1 && !this.plan.sku);
        if (this.product_type == 1) {
            if(!sku){
                //初始化占位数据
                let tpl = JSON.parse(JSON.stringify(sku_tpl))
                sku = [tpl];
                this.plan.sku = sku;
            }
            if(sku.length > 0){
                //初始化本地操作数据标识
                sku.forEach(v => {
                    let re = v.album && v.album.album_id || v.reply_switch || v.reply_random_switch || v.purchased_rich_text || v.post_id
                    this.$set(v,'is_show_option', re ? true : false)
                    this.$set(v,'is_show_ad_option', false)
                    if(v.post_id){
                      this.$set(v,'feed_switch', true)
                    }
                })
            }
        }
        let re = this.product_type == 0;
        let text =  {
            name: re ? this.$t('c.PlanEdit.text89') : this.is_bundle ? this.$t('c.PlanEdit.text90') : this.$t('c.PlanEdit.text91'),
            unit: re ? this.$t('c.PlanEdit.text92') : this.$t('c.PlanEdit.text93'),
            desc: re
                ? this.$t('c.PlanEdit.text94')
                : this.$t('c.PlanEdit.text95'),
        }
        let pay_month = this.plan.pay_month || '1';
        let vip_item = {
            name: this.$t('c.PlanEdit.text96'),
            value: 'all',
            plan_id: 'all',
        }
        
        let time_limit_price = plan.time_limit_price;
        let is_custom_discount = (time_limit_price && time_limit_price.discount == '') ? true : false;
        let discount = time_limit_price ? (is_custom_discount ? time_limit_price.price : time_limit_price.discount): '';
        let discount_index = '';
        let discount_list = [
            {name:this.$t('c.PlanEdit.text97'),discount_value: '',value: 'index_0', name2:''},
            // {name:'0元领取',discount_value: -1,value: 'index_1'},
            {name:this.$t('c.PlanEdit.text98'),discount_value:0.1,value: 'index_1'},
            {name:this.$t('c.PlanEdit.text99'),discount_value:0.2,value: 'index_2'},
            {name:this.$t('c.PlanEdit.text100'),discount_value:0.3,value: 'index_3'},
            {name:this.$t('c.PlanEdit.text101'),discount_value:0.4,value: 'index_4'},
            {name:this.$t('c.PlanEdit.text102'),discount_value:0.5,value: 'index_5'},
            {name:this.$t('c.PlanEdit.text103'),discount_value:0.6,value: 'index_6'},
            {name:this.$t('c.PlanEdit.text104'),discount_value:0.7,value: 'index_7'},
            {name:this.$t('c.PlanEdit.text105'),discount_value:0.8,value: 'index_8'},
            {name:this.$t('c.PlanEdit.text106'),discount_value:0.9,value: 'index_9'},
        ]
        if(time_limit_price){
          if(is_custom_discount){
              let price = time_limit_price.price
              // if(price != ''){
                discount_list[0].name2 = price;
                discount_list[0].discount_value = price;
                discount_index = 'index_0'
              // }else{
              //     discount_index = `index_1`;
              // }
          }else{
              let arr = discount_list.filter(v => v.discount_value == discount);
              discount_index = arr && arr[0].value
          }
        }
        // console.log(this._uid)
        return {
            text,
            plan_id: plan.plan_id || "",
            name: plan.name || "",
            price: plan.price || "",
            desc: plan.desc || "",
            pic: plan.pic || "",
            status: plan.status || 1,
            independent: plan.independent ? true : false, // 0,1 是否启用
            permanent: plan.permanent ? true : false, // 0,1 是否启用
            is_show_option: false,
            redeem_white_list: [
                "179f19102e7111e8bf4d52540025c377",
                "9e0d33fa340311e8ba9f52540025c377",
                "27f7cea2370d11e8ae8852540025c377",
                "80a0b7b47ff211ea990952540025c377",
            ],
            sku_item:{},
            reply_switch: r.reply_switch ? true : false, // 0,1 是否启用
            reply_content: r.reply_content, //通用回复内容
            reply_random_switch: r.reply_random_switch ? true : false, // 0,1 是否启用
            reply_random_content: r.reply_random_content, //随机回复内容
            can_buy_hide: plan.can_buy_hide ? true : false,
            need_address: plan.need_address ? true : false,
            pay_month,
            sku_tpl,
            sku,
            // modal_id:new Date().getTime(), // 弹窗标识
            modal_id:this._uid, // 弹窗标识
            favorable_price_pre: plan.favorable_price == -1 ? '': plan.favorable_price || '',
            // product_discount_price_pre:this.plan.product_discount_price || '',
            // product_discount_price_switch: this.plan.product_discount_price ? true : false,
            vip_price_switch: plan.vip_price ? true : false,
            vip_plan: plan.vip_plan,
            vip_price: plan.vip_price,
            conf: {
                // toolbarStickyOffset: 0,
                no_draft:true,
                heightMin:100,
                heightMax:400,
                placeholderText:text.desc,
                toolbarButtons:['insertImage','insertLink'],
            },
            sku_conf: {
                // toolbarStickyOffset: 0,
                no_draft:true,
                heightMin:100,
                heightMax:400,
                placeholderText: this.$t('c.PlanEdit.text107'),
                toolbarButtons:['insertImage','insertLink'],
            },
            vip_item,

            discount_index,
            is_time_limit_price: time_limit_price && time_limit_price.id ? true : false,
            begin_time: time_limit_price ? new Date(time_limit_price.begin_time * 1000) : 0,
            end_time: time_limit_price ? new Date(time_limit_price.end_time * 1000): 0,
            is_custom_discount,
            discount,
            discount_list,

            is_sale_type: [1,2,3,'1','2','3'].indexOf(this.product_type) != -1,
            is_include_history: plan.product_vip_price_include_history ? true : false,
            is_ignore_switch:false,
        };
    },
    watch: {
        // discount_index(val){
        //     console.log(val)
        //     if (val === 0) {
        //         let price = this.discount_list[0].name;
        //         this.$mixin_show_modal_price({
        //             title:'输入价格',
        //             content: price == '自选价格' ? '' : price
        //         })
        //     }else{
        //         this.discount_list[0].name = '自选价格'
        //         this.is_custom_discount = false;
        //     }
        // },
        independent(val) {
            if (!val) {
                this.permanent = val;
            }
        },
        permanent(val) {
            if (val) {
                this.independent = val;
            }
        },
        async can_buy_hide(val, oldVal) {
          if(!val){
            if(this.selected_plans.indexOf(this.plan.plan_id) != -1){
              let re = await this.$mixin_confirm({title:`这个赞助方案还关联了电圈哦，确定要设置为不可购买吗？`});
              if(re){
                this.pay_switch();
              }else{
                this.is_ignore_switch = true;
                this.can_buy_hide = true;
                this.$nextTick(() => {
                  this.is_ignore_switch = false;
                })
              }
              return false;
            }
          }
          this.pay_switch();
        },
        vip_price_switch(v){
            // if(!v){
            //     console.log(11)
            // }
        },
        // vip_all_plans(new_list){
        //     console.log(11)
        //     if(this.plan.vip_plan && new_list.length > 0){
        //         new_list.forEach(v => {
        //             if(v.plan_id == this.plan.vip_plan){
        //                 this.vip_item = {
        //                     name: this.make_vip_item_name(v),
        //                     value: v.price,
        //                     plan_id: v.plan_id,
        //                 }
        //             }
        //         })
        //     }
        // }
    },
    computed: {
        ...mapState("app", ["is_client", "upload", "plan_status", "browser_size",'white_list', 'vip_all_plans']),
        ...mapState('plan',['selected_plans']),
        vip_list(){
            let list = [
                { name: "所有会员", value: "all", plan_id:'all' },
            ];
            this.vip_all_plans.forEach((v, k) => {
                list.push({
                    name: this.make_vip_item_name(v),
                    value: v.price,
                    plan_id: v.plan_id,
                });
                if(v.plan_id == this.plan.vip_plan){
                    this.vip_item = {
                        name: this.make_vip_item_name(v),
                        value: v.price,
                        plan_id: v.plan_id,
                    }
                }
            });
            return list
        },
        is_hide() {
            return this.status == this.plan_status.hide;
        },
        is_hard_code_year_plan() {
            return this.plan && this.white_list.PLANS_YEAR.indexOf(this.plan.plan_id) != -1
        },
        is_hard_code_q_plan() {
            return this.plan && this.white_list.PLANS_Q.indexOf(this.plan.plan_id) != -1
        },
        can_add_product_post(){
          return (
              this.session_user &&
              this.session_user.rights &&
              this.session_user.rights.add_product_post
          );
        },
        can_add_attachment() {
            return (
                this.session_user &&
                this.session_user.rights &&
                this.session_user.rights.add_attachment
            );
        },
        post_data() {
            this.update_rich_text()
            let data = {
                plan_id: this.plan_id,
                name: this.name,
                price: this.price,
                // desc: this.desc,
                desc: this.product_type == 0 ? this.desc : this.$refs.editor.get_content(),
                pic: this.pic,
                status: this.status,
                reply_switch: this.reply_switch ? 1 : 0, // 0,1 是否启用
                reply_content: this.reply_content, //通用回复内容
                reply_random_switch: this.reply_random_switch ? 1 : 0, // 0,1 是否启用
                reply_random_content: this.reply_random_content, //随机回复内容
                independent: this.independent ? 1 : 0,
                permanent: this.permanent ? 1 : 0,
                need_address: this.need_address ? 1 : 0,
                product_type: this.product_type,
                pay_month:this.pay_month,
                sku: this.is_bundle ? this.bundle_sku_list: this.sku,
                favorable_price:this.pay_month == 1 ? '' : this.favorable_price_pre,
                // product_discount_price: this.product_discount_price_pre,
                product_vip_price: this.vip_price_switch ? this.vip_price : '',
                vip_price_related_plan_ids:this.vip_price_switch ? this.vip_item.plan_id : '',

                time_limit_begin:this.begin_time ? parseInt(this.begin_time.getTime() / 1000) : '',
                time_limit_end:this.end_time ? parseInt(this.end_time.getTime() / 1000) : '',
                has_time_limit_price:this.is_time_limit_price ? 1 : 0,
                time_limit_price: this.is_custom_discount ? this.discount : '',
                time_limit_discount: this.is_custom_discount ? '' : this.discount,

                bundle_stock:this.plan.bundle_stock,
                bundle_sku_select_count:this.plan.bundle_sku_select_count,

                product_vip_price_include_history:this.is_include_history ? 1 : 0,

                has_plan_config: this.plan.has_plan_config || 0,
                remark_name: this.plan.has_plan_config ? this.plan.config.remark_name : '',
                remark_placeholder: this.plan.has_plan_config ? this.plan.config.remark_placeholder : '',
                remark_required: this.plan.has_plan_config ? this.plan.config.remark_required : 0,
            }
            return data
        },
    },
    beforeDestroy() {
        this.$bus.$off("FEED_PUBLISH_SUCCESS");
        this.$bus.$off("MODAL_PRICE_SUBMIT");
    },
    beforeMount() {
        this.$bus.$off("MODAL_ALBUM_PICK_SUCCESS");
        this.$bus.$off("SHEET_PLAN_DESC");
        let data = {};
        // if(this.vip_all_plans.length == 0 && this.is_sale_type){
        //   if(this.is_bundle){
        //     data.sale_only = 1
        //   }
        // }
        if(this.is_bundle){
          data.post_only = 1
          data.sale_only = 1
          this.$store.dispatch('app/get:plan_list',data); //捆绑包时候，更新关联sku
        }
        if(this.vip_all_plans.length == 0 && this.product_type == 1){
            this.$store.dispatch('app/get:plan_list'); //新建方案时候，拿一次数据更新 vip_all_plans
        }
    },
    mounted() {
        this.$bus.$on("MODAL_ALBUM_PICK_SUCCESS", (data) => {
            if(data.modal_id == this.modal_id){
                let o = this.plan.sku[data.sku_index]
                this.$set(o,'album',data.album)
                this.$set(o,'album_id',data.album.album_id)
                if(data.album.cover){
                    this.sku_item.pic = data.album.cover;
                }
            }
        });
        this.$bus.$on("FEED_PUBLISH_SUCCESS", (data) => {
          if(data.modal_id != undefined){ //传回来的是 sku 的index
              let o = this.plan.sku[data.modal_id]
              this.$set(o,'post',data.post)
              this.$set(o,'post_id',data.post.post_id)
          }
        });
        this.$bus.$on("MODAL_PRICE_SUBMIT", (data) => {
          this.is_custom_discount = true;
          this.discount_list[0].name2 = data.content;
          this.discount_list[0].discount_value = data.content;
          this.discount = data.content;
        });
        this.$bus.$on("SHEET_PLAN_DESC", (data) => {
          if(data.modal_id == this.modal_id){
            let text = `· ${data.data.title}`;
            this.desc = this.desc != '' ? (this.desc + `\n${text}`) : `${text}`
          }
        });
    },
    methods: {
        dropdown_tap(item){
            if (item.i == 0) {
                this.$mixin_show_modal_price({
                    title:'输入价格',
                    content: this.discount_list[0].discount_value
                })
            }else{
                this.discount_list[0].name2 = ''
                this.discount_list[0].discount_value = ''
                this.is_custom_discount = false; //0元选取也是 自定义价格
                this.discount = this.discount_list[item.i].discount_value;
            }
        },
        make_vip_item_name(plan){
            let is_season_year = plan.pay_month == 3 || plan.pay_month == 12;
            let name = `${plan.permanent ? "永久方案 " : plan.independent ? "独立方案 ": ""} ￥${is_season_year ? (plan.show_price_after_adjust || plan.show_price) : plan.price}${plan.product_type == 1 ? " 售卖" : ""}${plan.product_type != 1 && !plan.independent && !is_season_year ? " 及以上" : ""}${plan.pay_month == 3 ? " /季" : ""}${plan.pay_month == 12 ? " /年" : ""}${plan.name ? " - " + plan.name : ""}`;
            name = name.length > 30 ? name.substr(0, 30) : name;
            return name
        },
        update_rich_text(){
            if(this.sku && this.sku.length > 0){
                this.sku.forEach((v, k) => {
                    if(this.$refs[`editor_${k}`] && !v.post_id){
                        v.purchased_rich_text = this.$refs[`editor_${k}`][0].get_content()
                    }
                })
            }
        },
        remove_album(index){
            let o = this.plan.sku[index];
            o.album = {};
            o.album_id = ''
        },
        sku_push() {
            let tpl = JSON.parse(JSON.stringify(this.sku_tpl))
            this.sku.push(Object.assign(tpl));
        },
        async sku_del(i){
            let re = await this.$mixin_confirm({ title: "确认删除吗？" });
            if (re) {
               this.sku.splice(i,1)
            }
        },
        async open_modal_feed(sku_index) {
        
          // this.$mixin_show_modal_feed()
          // return 0
          // console.log(item)
          let p = this.plan.sku.length > 0 && this.plan.sku[sku_index].post || {}
          this.$modal.show(
            () => import('@/components/ModalFeed'),
            {
              modal_id: sku_index,
              sku_post: 1,
              tit:'发布关联动态',
              title: p.title,
              post_id: p.post_id,
              pics: p.pics ? p.pics.map((v) => {
                return { online: v };
              }) : [],
              content: p.content,
              video_thumb: p.video_thumb,
              video: p.video,
              audio_thumb: p.audio_thumb,
              audio: p.audio,
              attachment: p.attachment ? p.attachment.map((v) => {
                return Object.assign(v, { success: true }); //为了组件内样式
              }) : [],
              status:p.status,
              cover:p.cover,
            },
            {
              pivotY: this.browser_size == 'small' ? 0.5 : 0.15,
              clickToClose: false,
              classes: 'v--modal-feed v--modal',
              height: this.browser_size == 'small' ? '100%' : 'auto',
              width: this.browser_size == 'small' ? '100%' : 1000,
              adaptive: this.browser_size == 'small' ? true : false,
            }
          );
        },
        del_sku_post(sku) {
          this.$modal.show('dialog', {
            // title: '是否确认删除动态',
            title:`本动态关联了${this.plan.name}的${sku.name}型号，确定要删除吗？`,
            buttons: [
              {
                title: this.$t('c.dialog.text1'),
                handler: () => {
                  this.$modal.hide('dialog');
                },
              },
              {
                title: this.$t('c.dialog.text2'),
                handler: async () => {
                  this.$modal.hide('dialog');
                  await this.del_feed(sku.post_id)
                  this.$nextTick(() => {
                    this.$delete(sku,'post')
                    this.$delete(sku,'post_id')
                  })
                },
              },
            ],
          });
        },
        async del_feed(post_id) {
          if (this.$http.is_run(POST_POST_DELETE)) {
            return false;
          }
          let data = await this.$http.$axios(POST_POST_DELETE, { post_id });
          if (data.ec != 200) {
            this.$notify({
              title: data.em,
              group: 'error',
            });
          }
        },
        tab_option() {
            this.is_show_option = !this.is_show_option;
        },
        tab_sku_option(item) {
            if(item.is_show_option){
                this.update_rich_text()
            }
            item.is_show_option = !item.is_show_option;
        },
        tab_sku_ad_option(item) {
            item.is_show_ad_option = !item.is_show_ad_option;
        },
        pick_item(item){
            this.sku_item = item;
        },
        pick_album(item, i){
            this.$mixin_show_modal_album_pick({
                modal_id: this.modal_id,
                user_id: this.session_user.user_id,
                sku_index: i
            })
            this.pick_item(item)
        },
        image_upload(data) {
            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
            }
            this.pic = data.data.url;
        },
        image_sku_upload(data) {
            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
            }
            this.sku_item.pic = data.data.url;
        },
        errorhandle(err_text) {
            if (/FILE IS TOO LARGER MAX FILE/.test(err_text)) {
                err_text = `上传文件最大为: ` + err_text.split(" ").pop();
            }
            this.$notify({
                title: err_text,
                group: "error",
            });
        },
        remove_pic() {
            this.pic = "";
        },
        remove_sku_pic(sku){
            sku.pic = '';
        },
        tip(str) {
            this.$notify({
                title: str,
            });
        },
        async toggle(type) {
            let API =
                type == "show"
                    ? POST_CREATOR_SHOW_PLAN
                    : POST_CREATOR_HIDE_PLAN;
            if (this.$http.is_run(API)) {
                return false;
            }
            let data = await this.$http.$axios(API, { plan_id: this.plan_id });

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                return false;
            }
            this.status =
                type == "show"
                    ? this.plan_status.normal
                    : this.plan_status.hide;
        },
        async remove() {
            let re = await this.$mixin_confirm({ title: "确认删除吗？" });
            if (!re) {
                return false;
            }
            if (!this.plan_id) {
                //如果是个不存在的plan，就是前端伪造的占位plan
                this.$emit('remove');
                return false;
            }

            if (this.$http.is_run(POST_DEL_PLAN)) {
                return false;
            }
            let data = await this.$http.$axios(POST_DEL_PLAN, {
                plan_id: this.plan_id,
            });

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? 'success' : 'error',
            });

            if (data.ec == 200) {
                this.$emit('remove');
                return true
            }
        },
        async save(param = null) {
            // console.log(this.is_custom_discount)
            // console.log(this.post_data)
            if (this.$http.is_run(POST_EDIT_PLAN)) {
                return false;
            }
            if(param){
                this.post_data.status = param.status;
            }
            let data = await this.$http.$axios(POST_EDIT_PLAN, this.post_data);

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? 'success' : 'error',
            });
            if(data.ec != 200){
                return false
            }


            if (data.ec == 200) {
                this.plan_id = data.data.plan.plan_id;
                if(this.index * 1 >= 0){
                    this.$emit("save", {
                        plan: data.data.plan,
                        index: this.index,
                    });
                }
            }
            return { plan: data.data.plan,index: this.index}
        },
        async pay_switch() {
            if (this.$http.is_run(POST_SET_CAN_BUY_HIDE) || this.is_ignore_switch) {
                return false;
            }
            let data = await this.$http.$axios(POST_SET_CAN_BUY_HIDE, {
                plan_id: this.plan.plan_id,
                status: this.can_buy_hide ? 1 : 0,
            });

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? 'success' : 'error',
            });

            if (data.ec == 200) {
                // this.plan_id = data.data.plan.plan_id;
                // this.$emit("save", {
                //     plan: data.data.plan,
                //     index: this.index,
                // });
            }
        },
        open_sheet_plan_desc(){
          this.$mixin_show_sheet_plan_desc({
            modal_id:this.modal_id
          })
        }
    },
};
</script>

<style lang="stylus" scoped>
.vm-plan-edit {
  background: $white;
  border-radius: 4px;
  border: 1px solid $grey;
  position: relative;
  padding: 24px 16px;

  .add-sku-btn{
      border:1px solid $black-1;
      padding:10px 0;
  }
  .afd-eye-off-box, .afd-eye, .del-x-1 {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;

    &:hover {
      color: $black-8;
    }
  }
  .del-x-2{

  }
  .icon-box{
      width:24px;
      height:24px;
      background:$white-bg;
  }

  .goods-index {
    // border-bottom: 1px solid #e3e3e3;
  }

  .goods-num-input {
    border: 1px solid #e3e3e3;
    padding: 10px 12px;
    width: 90px;
  }

  .goods-textarea {
    height: 70px;
  }

  .afd-eye-off-box, .afd-eye {
    right: 48px;
    z-index: 1;
  }

  .w75 {
    width: 75%;
  }

  .money-input {
    border: 0;
    outline: 0;
    width: 120px;
  }

  .tab-option {
    // background: #f3f3f3;
    padding: 8px 0;
    color: $black-8;
    border-bottom:1px solid $black-1;
  }

  .img-box {
    max-width: px2rem(320);

    .img-pre-box {
      margin-bottom: px2rem(16);

      img {
        width: auto;
        max-width: 100%;
      }
    }
  }
  .afd-link{
      height:16px;
  }

  &.is-hide {
    height: 52px;
    overflow: hidden;

    .over {
      background: $black-1;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: absolute;
    }

    .pay-switch {
      background: $white;
      margin-top: 52px;
      border-radius: 2px;
    }
  }

  .auto-reply {
    width: 86%;
  }

  .item-box{
    .cover{
        width: 64px;
        height: 64px;
        border-radius: 5px;
    }
  }
  .vm-editor{
      border:1px solid $black-1;
  }
  .price-box{
      border:1px solid $black-1;
  }
  .discount-dropdown /deep/{
    width: 210px;
    box-sizing: border-box;
    height:34px;
    color: #555;
    .show-area{
        padding: 7px 10px !important;
        line-height: 1;
    }
  }

  @media (max-width: $width-mobile) {
    .img-box {
      max-width: 100%;
    }
  }
}
</style>
